import React from 'react';
import withStyles from '@mui/styles/withStyles';
import { withRouter } from '../../utils/withRouter';
import { compose } from '../../reactApolloCompat';
import TaskWorkspace from './TaskWorkspace';

export default compose(
    withRouter,
    withStyles({})
)(({ tasks, refetch }) => {
    return (
        <div className="star-draw-container" style={{ padding: '0 26px' }}>
            <div className="star-draw-body">
                {(!!tasks && tasks.length > 0 && <TaskWorkspace tasks={tasks} refetch={refetch} />) || (
                    <p>You currently have no starred tasks.</p>
                )}
            </div>
        </div>
    );
});
